import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'
import { lazy } from 'react'

const Inner = lazy(() => import('./Inner'))

/**
 * Dialog host for tax profile related dialogs.
 */
export const TaxProfileDialogsHost = observer(function TaxProfileDialogsHost() {
  const { isTaxProfileRequested } = useFeatures(({ taxProfile }) => ({
    isTaxProfileRequested: taxProfile.internal.isRequested,
  }))

  if (!isTaxProfileRequested()) {
    return null
  }

  return <Inner />
})
